import { IconQuestionMarkOutline } from '@iwoca/icons';
import { Accordion } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const RCFFAQs = ({
    trackFaqClicked
}: {
    trackFaqClicked: (faqTitle: string) => void;
}) => {
    return (
        <div className="flex flex-col gap-s">
            <Accordion
                frame
                icon={<IconQuestionMarkOutline />}
                title={
                    <FormattedMessage
                        id="_.faqs.rcf_how_often_can_i_withdraw"
                        defaultMessage="How often can I withdraw money?"
                    />
                }
                small
                data-testid="how-often-can-i-withdraw-money"
                onClick={() =>
                    trackFaqClicked('How often can I withdraw money?')
                }
            >
                <FormattedMessage
                    id="_.faqs.rcf_how_often_can_i_withdraw_description_1"
                    defaultMessage="You can access your available funds as often as you like and free of charge."
                />
                <br />
                <br />
                <FormattedMessage
                    id="_.faqs.rcf_how_often_can_i_withdraw_description_2"
                    defaultMessage="As a responsible partner, we conduct regular checks in accordance with our contractual terms. If there are changes in your credit file, we reserve the right to temporarily pause further withdrawals from your credit line. This helps us ensure together that repayments remain manageable for your business."
                />
            </Accordion>
            <Accordion
                frame
                icon={<IconQuestionMarkOutline />}
                title={
                    <FormattedMessage
                        id="_.faqs.rcf_when_does_my_access_end"
                        defaultMessage="When does my access to the credit line end?"
                    />
                }
                small
                data-testid="when-does-my-access-end"
                onClick={() =>
                    trackFaqClicked(
                        'When does my access to the credit line end?'
                    )
                }
            >
                <FormattedMessage
                    id="_.faqs.rcf_when_does_my_access_end_description_1"
                    defaultMessage="You can withdraw money throughout the entire interest-free period (12 months). After that, the phase begins in which you will need to repay the amount used according to plan."
                />
                <br />
                <br />
                <FormattedMessage
                    id="_.faqs.rcf_when_does_my_access_end_description_2"
                    defaultMessage="We will contact you 30 days before the end to discuss your renewal options."
                />
                <br />
                <br />
                <FormattedMessage
                    id="_.faqs.rcf_when_does_my_access_end_description_3"
                    defaultMessage="To keep your credit line active, good creditworthiness is important. If your financial situation deteriorates significantly, iwoca has the right to close your facility to protect both parties."
                />
                <br />
                <br />
                <FormattedMessage
                    id="_.faqs.rcf_when_does_my_access_end_description_4"
                    defaultMessage="We can only do so after the first 3 months, and in such a case we will give you 30-days notice before you will need to begin repaying your outstanding loan amount"
                />
            </Accordion>
            <Accordion
                frame
                icon={<IconQuestionMarkOutline />}
                title={
                    <FormattedMessage
                        id="_.faqs.rcf_can_i_increase_my_credit_limit"
                        defaultMessage="Can I increase my credit limit?"
                    />
                }
                small
                data-testid="can-i-increase-my-credit-limit"
                onClick={() =>
                    trackFaqClicked('Can I increase my credit limit?')
                }
            >
                <FormattedMessage
                    id="_.faqs.rcf_can_i_increase_my_credit_limit_description_1"
                    defaultMessage="Currently, it is not possible to change your limit yourself. However, iwoca is already working on new features to allow you to adjust your credit limit more flexibly soon."
                />
                <br />
                <br />
                <FormattedMessage
                    id="_.faqs.rcf_can_i_increase_my_credit_limit_description_2"
                    defaultMessage="Help us make the Flexi credit line even better: just talk to our team and share your wishes and ideas."
                />
            </Accordion>
            <Accordion
                frame
                icon={<IconQuestionMarkOutline />}
                title={
                    <FormattedMessage
                        id="_.faqs.rcf_how_can_i_close_my_rcf"
                        defaultMessage="How can I close my Flexi-Rahmenkredit?"
                    />
                }
                small
                data-testid="how-can-i-close-my-rcf"
                onClick={() =>
                    trackFaqClicked('How can I close my Flexi-Rahmenkredit?')
                }
            >
                <FormattedMessage
                    id="_.faqs.rcf_how_can_i_close_my_rcf_description_1"
                    defaultMessage="You can close your facility at any time after the first 3 months by contacting us."
                />
                <br />
                <br />
                <FormattedMessage
                    id="_.faqs.rcf_how_can_i_close_my_rcf_description_2"
                    defaultMessage="After a 30-day notice period, you will automatically begin repaying your outstanding loan amount. If you need access to new funds afterwards, submit a new application."
                />
            </Accordion>
        </div>
    );
};
